import * as R from "ramda";

export const formattedValidRecipients = validRecipients =>
  R.map(particularContact => {
    const meta = R.pathOr({}, ["meta"])(particularContact);
    const { name, id, email } = meta;
    return {
      value: name,
      id,
      email,
      selected: true
    };
  }, validRecipients);
